import { Stack, useMediaQuery } from "@mui/material";
import { secondaryModelData } from "../services/modelsData";
import { SecondaryModelCardAtom } from "../atoms/secondary-model-card-atom";
import { MainModelAtom } from "../atoms/main-model-atom";
import { theme } from "../styles/mui-theme";
import { GradientBgAtom } from "../atoms/gradient-bg-atom";

export const ModelsMolecule = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.only("md"));
  const isUltraHd = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        height: "100vh",
        maxWidth: isUltraHd ? "2000px" : "1000px",
        overflow: "hidden",
        "&::before": !isMobile && {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(to right, #141414 1%, rgba(20, 20, 20, 0.00) 30%)",
          zIndex: 5,
          pointerEvents: "none",
        },
      }}
    >
      {!isMobile && <GradientBgAtom />}
      {secondaryModelData.map((model) => (
        <SecondaryModelCardAtom
          imgSrc={model.imgSrc}
          key={model.id}
          position={model.position}
          isBackSide={model.isBackSide}
          isHidden={model.isHidden}
        />
      ))}
      <MainModelAtom />
    </Stack>
  );
};
